module.exports = __webpack_public_path__ + "static/react-banner-normal-eb17c370ba933715fb5e5e3e8c6df78f.jpg";